module.exports = __webpack_public_path__ + "static/media/3_Ensure-Correct-Wall-Recess-Size-Good.f1c238d9.svg";